import {
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

type ContextoTitulo = {
  titulo: string;
  subtitulo: string;
  setTitulo: Dispatch<SetStateAction<string>>;
  setSubtitulo: Dispatch<SetStateAction<string>>;
};

const TitleContext = createContext<ContextoTitulo>(null);

// 2. Crear un proveedor
export const TituloProvider: FC<PropsWithChildren> = ({ children }) => {
  const [titulo, setTitulo] = useState<string>(null);
  const [subtitulo, setSubtitulo] = useState<string>(null);

  const value = useMemo(
    () => ({ titulo, setTitulo, subtitulo, setSubtitulo }),
    [titulo, setTitulo, subtitulo, setSubtitulo]
  );

  return (
    <TitleContext.Provider value={value}>{children}</TitleContext.Provider>
  );
};

// 3. Hook para obtener el contexto completo
export const useTitulo = () => useContext(TitleContext);

// 4. Hook para manejar el titulo y subtitulo de la cabecera entre paginas
export const useTituloPagina = (
  titulo?: ContextoTitulo['titulo'],
  subtitulo?: ContextoTitulo['subtitulo']
) => {
  const { setTitulo, setSubtitulo } = useTitulo();

  useEffect(() => {
    setTitulo(titulo);
    setSubtitulo(subtitulo);
  }, [setSubtitulo, setTitulo, titulo, subtitulo]);
};
